<template>
    <div v-if="active" class="vue-box">
        <div class="frame">
            <slot class="title" name="title"></slot>
            <slot name="content"></slot>
        </div>
    </div>
</template>
<script>
    export default {
        name: 'Box',
        props: [
            'active',
        ],
        components: {
        }
    }
</script>
<style scoped>
    /* @import "./Box.scss" */
    .vue-box {
  width: 300px;
  height: 150px;
  background-color: #174ab8;
  padding: 5px;
  color: #fff;
  display: inline-block;
  -webkit-box-shadow: 0px 2px 45px 0px rgba(176,176,176,1);
  box-shadow: 0px 2px 45px 0px rgba(176,176,176,1);
  position: absolute;
  top: 470px;
  left: 200px;
}

.title {
  color: #fff;
}

.content {
  font-size: 10px;
}

.frame {
  border: 1px solid #fff;
  height: 100%;
}

/* // Small devices (landscape phones, 576px and up) */
@media (min-width: 576px) {

}

/* // Medium devices (tablets, 768px and up) */
@media (min-width: 768px) {

}

/* // Medium devices (tablets, 768px and up) */
@media (max-width: 768px) {

}

/* // Large devices (desktops, 992px and up) */
@media (min-width: 992px) {

}

/* // Extra large devices (large desktops, 1200px and up) */
@media (min-width: 1200px) {

}
</style>


// WEBPACK FOOTER //
// src/components/coverage/box/Box.vue